import { render, staticRenderFns } from "./HomeTestView.vue?vue&type=template&id=6535e89a"
import script from "./HomeTestView.vue?vue&type=script&lang=ts"
export * from "./HomeTestView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports